import {getProducts} from './products';

export const apiProducts = {
  getProducts,
};
